module.exports = __webpack_public_path__ + "img/icon_play_2.b9bfbb63.svg";